<template>
  <div class="detail-list-box">
    <table>
      <tr>
        <td>
          <div class="text-1">
            Order ID<span>{{ this.links.order_id }}</span>
          </div>
        </td>
        <td>
          <div class="text-1">
            Link ID <span>{{ this.links.link_id }}</span>
          </div>
        </td>
        <td>
          <div class="text-1">
            Status <span>{{ this.links.status }}</span>
          </div>
        </td>
        <td>
          <div class="text-1">
            DA
            <span>{{ this.links.product_name }}</span>
          </div>
        </td>
      </tr> 
      <tr>
        <td v-if="this.links.missed_opportunities">
          <div class="text-1">
            Live DA
            <span>{{ this.links.domain_authority }}</span>
          </div>
        </td>
        <td v-else>
          <div class="text-1">
            Domain Authority
            <span>{{ this.links.domain_authority }}</span>
          </div>
        </td>
        <td>
          <div class="text-1">
            Spam Score <span>{{ this.links.spam_score }}</span>
          </div>
        </td>
        <td v-if="!this.links.missed_opportunities">
          <div class="text-1">
            Do Follow <span>{{ this.links.do_follow }}</span>
          </div>
        </td>
        <td v-if="this.links.missed_opportunities">
          <div class="text-1">
            Traffic <span>{{ Math.floor(this.links.traffic).toLocaleString()}}</span>
          </div>
        </td>
        <td v-if="this.links.missed_opportunities">
          <div class="text-1">
            DA Date <span>{{ this.links.da_dr_date }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="1">
          <div class="text-1">
            Primary Category<span>{{
              this.links.primary_category
            }}</span>
          </div>
        </td>
        <td colspan="1">
          <div class="text-1">
            Secondary Category
            <span>{{ this.links.secondary_category }}</span>
          </div>
        </td>
        <td v-if="this.links.missed_opportunities">
          <div class="text-1">
            Do Follow <span>{{ this.links.do_follow }}</span>
          </div>
        </td>
        <td v-if="this.links.missed_opportunities">
          <div class="text-1">
            Order Type <span>{{ this.links.mo_order_type }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="text-1">
            Placement URL<span class="destination-link-text">{{
              this.links.placement_authority
            }}</span>
          </div>
        </td>
        <td colspan="2">
          <div class="text-1">
            Publish date <span>{{ this.links.publish_date }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="text-1">
            Destination URL<span class="destination-link-text">{{
              this.links.url
            }}</span>
          </div>
        </td>
        <td colspan="2">
          <div class="text-1">
            Anchor Text: <span>{{ this.links.text }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <div class="text-1">
            Live URL<span class="bText">{{
              this.links.live_link
            }}</span>
          </div>
        </td>
      </tr>
      <template v-if="!this.links.packageOrder">
          <tr class="addon-text">
            <td><span>Add-On</span></td>
          </tr>
          <tr class="addon-bg-box">
            <td colspan="1" v-if="!this.links.missed_opportunities">
              <div class="text-1">
                Minimum Traffic<span>{{
                  this.links.minimum_traffic == ""
                    ? "No"
                    : this.links.minimum_traffic
                }}</span>
              </div>
            </td>
            <td colspan="1">
              <div class="text-1">
                Content Approval
                <span>{{
                  this.links.content_approval == ""
                    ? "No"
                    : this.links.content_approval
                }}</span>
              </div>
            </td>
            <td colspan="2" v-if="!this.links.missed_opportunities">
              <div class="text-1">
                UK TLD
                <span>{{
                  this.links.uk_tld == ""
                    ? "No"
                    : this.links.uk_tld
                }}</span>
              </div>
            </td>
          </tr>
        </template>
    </table>
  </div>
</template>

<script>
export default {
  props: ['activeLink'],
  data() {
    return {
      links: [],
    };
  },
  watch: {
    activeLink() {
      this.links = this.activeLink;
      console.log(this.links);
    },
  },
  mounted() {
    // Optional logic
  },
  methods: {
    // Your methods (if any)
  },
  computed: {
    // Your computed props (if any)
  },
};
</script>

